<div class="dividends-container">
    
    <div class="header">
        <div class="left">
            <h2 mat-title>Fixed-incomes</h2>
        </div>
        <div class="right">
            <button mat-icon-button (click)="create()">
                <mat-icon class="material-symbols-outlined">{{icons.add}}</mat-icon>
            </button>
        </div>
    </div>
    <div>
        <table mat-table [dataSource]="list.data">
            
            <ng-container *ngFor="let col of list.columns; let colIndex = index" matColumnDef="{{col}}">
                <th mat-header-cell *matHeaderCellDef style="text-transform: capitalize;"> {{col}} </th>
                
                <td mat-cell *matCellDef="let element">
                    @if (col != 'action' && col != 'profitability')
                    {
                        <span *ngIf="isTimestamp(element[col])">{{element[col].seconds * 1000 | date}}</span>
                        <span *ngIf="isNumber(element[col])">{{element[col] | number: '1.2-2' | currency}}</span>
                        <span *ngIf="isText(element[col])">{{element[col]}}</span>
                    } 
                    @if (col != 'action' && col == 'profitability')
                    {
                        <span>{{element[col] | percentage}}</span>
                    } 
                    @if (col == 'action') {
                        <button mat-icon-button (click)="modify(element)">
                            <mat-icon class="material-symbols-outlined" color="primary">{{icons.edit}}</mat-icon>
                        </button>
                        <button mat-icon-button (click)="delete(element)">
                            <mat-icon class="material-symbols-outlined" color="primary">{{icons.delete}}</mat-icon>
                        </button>
                    }
                </td>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="list.columns"></tr>
            <tr mat-row *matRowDef="let row; columns: list.columns;"></tr>

        </table>
    </div>
</div>